import React from "react";

class CustomerSelect extends React.Component {

  constructor(props) {
    super(props);
    this.processCustomerName = this.processCustomerName.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.customer && typeof nextProps.customer.id === 'undefined') {
      $(this.refs.customers).val(null).trigger('change');
    }
  }

  componentDidMount () {
    var self = this;

    if (this.refs.customers) {
      $(this.refs.customers).select2({
        ajax: {
          url: '/admin/customers_remote',
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term,
              page: params.page,
              results_per_page: 40,
              reservation_id: self.props.reservation_segment ? self.props.reservation_segment.reservation_id : null,
              reservation_segment_id: self.props.reservation_segment ? self.props.reservation_segment.id : null,
              call_source: self.props.callSource,
            };
          },
          processResults: function (data, params) {
            params.page = params.page || 1;

            return {
              results: data.items,
              pagination: {
                more: (params.page * 40) < data.total_count
              }
            };
          },
          cache: true
        },
        allowClear: this.props.allowClear ? this.props.allowClear : false,
        escapeMarkup: function (markup) {
          return markup;
        },
        placeholder: I18n.t('select_ellipsis'),
        templateResult: function (customer) {
          if (customer.loading || customer.id == '' || customer.id == null) {
            return customer.text;
          }

          return self.processCustomerName(customer);
        },
        templateSelection:  (customer) => {
          if (customer && customer.id != null && customer.id != '') {
            this.props.callSource === 'paymentBuilder' && this.props.customer && this.props.customer.cards && this.props.customer.id === customer.id ? customer = this.props.customer : null
            
            customer.header = self.props.name
            self.props.onChange(customer);

            return self.processCustomerName(customer);
          } else {
            return customer.text;
          }
        }
      }).on('select2:unselect', function () {
        if (self.props.name) {
          var room = {header: self.props.name, full_name: null}
          self.props.onChange(room);
        } else {
          self.props.onChange(null);
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.customer === null) {
      $(this.refs.customers).val(null).trigger('change');
    }
    if (this.props.error && prevProps && !prevProps.error){
      $(this.refs.customers).next().find('.select2-selection__rendered').addClass('has-errors');
    } else if (!this.props.error && prevProps && prevProps.error){
      $(this.refs.customers).next().find('.has-errors').removeClass('has-errors');
    };
  };

  render() {
    return (
      <select className="form-control" ref="customers" style={{width: '100%', minHeight: 33}} disabled={this.props.disabled}>
        {this.props.customer ? <option value={this.props.customer.id}>{this.processCustomerName(this.props.customer)}</option> : null}
      </select>
    );
  }

  processCustomerName(customer) {
    if (customer.first_name && customer.last_name) {
      var markup = customer.first_name + ' ' + customer.last_name + (customer.email ? ' (' + customer.email + ')' : '')

      if (customer.city && customer.state) {
        markup = markup + ' - ' + customer.city + ', ' + customer.state;
      }

      return markup;
    } else {
      return customer.text;
    }
  }

};

export default CustomerSelect